export const meta = {
  title: '服务条款 | PDFCraftTool',
  description:
    '使用 PDFCraftTool.org（免费 PdfCraft PDF 编辑器的独立下载、安装与对比指南站）的条款。',
  updated_at: '2026-10-15',
};

## 协议

本条款适用于你对 pdfcrafttool.org（以下简称「PDFCraftTool」「我们」）的使用。使用本站即表示你同意本条款；如不同意，请勿使用本站。联系方式：[support@pdfcrafttool.org](mailto:support@pdfcrafttool.org)。

## PDFCraftTool 是什么

PDFCraftTool 是关于 PdfCraft 的独立资讯网站。PdfCraft 是 ArtCraft 团队开发的免费开源 PDF 编辑器。我们提供下载链接、安装指南、使用教程、与 Adobe Acrobat 的功能对比和实际使用体验，并托管一份由 ArtCraft 发布、未经修改的 PdfCraft 网页版。

PDFCraftTool **不是** PdfCraft 官方网站，与 ArtCraft 及 Adobe Inc. 均无隶属、赞助或背书关系。PdfCraft 官方页面为 [getartcraft.com/apps/pdfcraft](https://getartcraft.com/apps/pdfcraft)，源代码位于 [GitHub](https://github.com/storytold/pdfcraft)。

## PdfCraft 软件

PdfCraft 由 ArtCraft 创作并发布，你可选择适用 MIT 或 Apache-2.0 许可证。你对 PdfCraft（包括桌面版和 PdfCraft 在线版）的使用受该许可证约束，软件按「现状」提供，不附带任何担保。我们不开发、不修改也不提供该软件的技术支持；问题反馈和功能建议请提交到 PdfCraft 官方仓库。

我们的下载按钮指向 GitHub 上的 PdfCraft 发布页（github.com/storytold/pdfcraft/releases）。建议在安装前使用发布页提供的 SHA-256 校验值核验文件。

## 本站信息

我们努力保证指南与对比内容准确，但 PdfCraft 仍处于 alpha 阶段、每隔几天就会更新，Adobe 也会定期调整 Acrobat 的功能和价格。本站内容仅供一般参考。价格、功能与兼容性说明反映的是标注日期时的调研结果，可能已经过时。做出购买或部署决定前，请以官方信息为准。

## 商标

PdfCraft 和 ArtCraft 是 ArtCraft 团队的名称与商标。Adobe 和 Acrobat 是 Adobe Inc. 的商标或注册商标。本站使用这些名称仅为指明所介绍的产品。PdfCraft 截图来自 PdfCraft 项目。PDFCraftTool 的名称、标志、文字与设计归我们所有。

## 使用规范

你同意不会：

- 攻击本站、使其过载、以滥用频率抓取内容或试图破坏本站安全；
- 使用本站或 PdfCraft 在线版处理你无权使用的材料，或用于任何违法目的；
- 未经许可大量复制本站指南并以自己的名义重新发布；
- 冒充 PDFCraftTool、ArtCraft 或 Adobe。

## 可选账号

部分功能可能需要账号。请妥善保管登录信息，如发现未经授权的访问请立即告知我们。对违反本条款的账号，我们可能暂停其使用。

## 第三方链接

本站链接到 GitHub、getartcraft.com、adobe.com 和 Discord 等第三方网站。我们无法控制这些网站，对其内容、可用性或政策不承担责任。

## 免责与责任限制

本站及 PdfCraft 在线版按「现状」和「现有」基础提供，不附带任何形式的担保。请为重要文档保留备份。在法律允许的最大范围内，对于因使用本站、本站信息或通过本站下载的软件而产生的任何间接、附带或后果性损害、数据丢失或利润损失，PDFCraftTool 概不负责。

## 条款变更

我们可能更新本条款。页面顶部日期为最新修订日期，继续使用本站即表示你接受更新后的条款。

## 联系我们

关于本条款的问题：[support@pdfcrafttool.org](mailto:support@pdfcrafttool.org)。
